import { useEffect, useState } from 'react';
import API from '../api';

const S_LABEL = { new:'Новая', in_progress:'В работе', done:'Выполнена', cancelled:'Отменена' };
const S_COLOR  = { new:'#3B82F6', in_progress:'#F97316', done:'#22C55E', cancelled:'#EF4444' };
const S_BG     = { new:'#EFF6FF', in_progress:'#FFF7ED', done:'#F0FDF4', cancelled:'#FEF2F2' };

function StatCard({ icon, value, label, color, bg }) {
  return (
    <div style={{ background:'#fff', borderRadius:14, padding:'20px 22px', boxShadow:'0 1px 8px rgba(0,0,0,0.06)', border:'1px solid #F0F0F0', display:'flex', alignItems:'center', gap:16 }}>
      <div style={{ width:46, height:46, borderRadius:12, background:bg||'#F0FFFE', display:'grid', placeItems:'center', fontSize:'1.4rem', flexShrink:0 }}>{icon}</div>
      <div>
        <div style={{ fontFamily:"'Unbounded',sans-serif", fontSize:'1.7rem', fontWeight:900, color:'#06101e', lineHeight:1 }}>{value ?? '—'}</div>
        <div style={{ color:'#9CA3AF', fontSize:'0.8rem', marginTop:4, fontWeight:500 }}>{label}</div>
      </div>
    </div>
  );
}

function Badge({ status }) {
  return <span style={{ display:'inline-block', padding:'3px 10px', borderRadius:20, fontSize:'0.72rem', fontWeight:700, background:S_BG[status]||'#F5F5F5', color:S_COLOR[status]||'#6B7280' }}>{S_LABEL[status]||status}</span>;
}

export default function AdminDashboard() {
  const [stats, setStats]   = useState(null);
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    API.get('/admin/stats').then(r => setStats(r.data)).catch(()=>{});
    API.get('/admin/orders').then(r => setOrders(r.data.slice(0,6))).catch(()=>{});
  }, []);

  return (
    <div>
      <div style={{ marginBottom:24 }}>
        <h1 style={{ fontFamily:"'Unbounded',sans-serif", fontWeight:800, fontSize:'1.4rem', color:'#06101e', margin:'0 0 4px' }}>Дашборд</h1>
        <p style={{ color:'#9CA3AF', fontSize:'0.875rem', margin:0 }}>Обзор активности MasterClean Pro</p>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(180px,1fr))', gap:14, marginBottom:28 }}>
        <StatCard icon="📋" value={stats?.total}      label="Всего заявок"   bg="#F0FFFE" />
        <StatCard icon="🆕" value={stats?.new}        label="Новые"          bg="#EFF6FF" />
        <StatCard icon="🔧" value={stats?.inProgress} label="В работе"       bg="#FFF7ED" />
        <StatCard icon="✅" value={stats?.done}        label="Выполнено"      bg="#F0FDF4" />
        <StatCard icon="🧹" value={stats?.services}   label="Активных услуг" bg="#FAF5FF" />
      </div>

      <div style={{ background:'#fff', borderRadius:14, boxShadow:'0 1px 8px rgba(0,0,0,0.06)', border:'1px solid #F0F0F0', overflow:'hidden' }}>
        <div style={{ padding:'16px 22px', borderBottom:'1px solid #F5F5F5', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <h2 style={{ fontFamily:"'Unbounded',sans-serif", fontWeight:700, fontSize:'0.95rem', color:'#06101e', margin:0 }}>Последние заявки</h2>
          <a href="/admin/orders" style={{ color:'#00C2B8', fontSize:'0.82rem', fontWeight:700, textDecoration:'none' }}>Все →</a>
        </div>
        {orders.length === 0 ? (
          <div style={{ padding:48, textAlign:'center', color:'#D1D5DB' }}>
            <div style={{ fontSize:'2.5rem', marginBottom:10 }}>📭</div>
            Заявок пока нет
          </div>
        ) : (
          <div style={{ overflowX:'auto' }}>
            <table style={{ width:'100%', borderCollapse:'collapse' }}>
              <thead>
                <tr style={{ background:'#FAFAFA' }}>
                  {['Клиент','Телефон','Услуга','Дата','Статус'].map(h => (
                    <th key={h} style={{ padding:'10px 18px', textAlign:'left', fontSize:'0.72rem', fontWeight:700, color:'#9CA3AF', textTransform:'uppercase', letterSpacing:'0.06em', whiteSpace:'nowrap' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {orders.map((o,i) => (
                  <tr key={o.id} style={{ borderTop:'1px solid #F5F5F5' }}>
                    <td style={{ padding:'12px 18px', fontWeight:600, fontSize:'0.9rem', color:'#111' }}>{o.name}</td>
                    <td style={{ padding:'12px 18px', color:'#6B7280', fontSize:'0.85rem' }}>{o.phone}</td>
                    <td style={{ padding:'12px 18px', fontSize:'0.85rem', color:'#374151', maxWidth:160, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{o.service||'—'}</td>
                    <td style={{ padding:'12px 18px', color:'#9CA3AF', fontSize:'0.8rem', whiteSpace:'nowrap' }}>{o.date||new Date(o.createdAt).toLocaleDateString('ru-RU')}</td>
                    <td style={{ padding:'12px 18px' }}><Badge status={o.status}/></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
